import React from 'react';
import styled from 'styled-components/macro';
import { WithTranslation, withTranslation } from 'react-i18next';
import RevenueValue from './RevenueValue';

interface RevenueProps extends WithTranslation{
    generatedRevenue: number;
    avgTransactionCost: number;
    avgDaysBetweenPurchase: number;
    currency: string;
}

const RevenueSummary = (
    {
        generatedRevenue,
        avgTransactionCost,
        avgDaysBetweenPurchase,
        currency,
        t,
    }: RevenueProps
) => {
    return (
        <FlexContainer>
            <FlexItem>
                <ItemHeader>{t('customers.summary.generated_revenue')}</ItemHeader>
                <RevenueValue amount={generatedRevenue} currency={currency} />
            </FlexItem>
            <FlexItem>
                <ItemHeader>{t('customers.summary.average_transaction_cost')}</ItemHeader>
                <RevenueValue amount={avgTransactionCost} currency={currency} />
            </FlexItem>
            <FlexItem>
                <ItemHeader>{t('customers.summary.average_days_between_purchase')}</ItemHeader>
                <RevenueValue amount={avgDaysBetweenPurchase} hideCurrency />
            </FlexItem>
        </FlexContainer>
    );
};

export default withTranslation()(RevenueSummary);

const FlexContainer = styled.div`
    display: flex;
    @media (max-width: 1024px) {
        flex-direction: column;
    }
`;

const FlexItem = styled.div`
    flex: 1 1 auto;
    @media (max-width: 1024px) {
        margin-top: 12px;
    }
`;

const ItemHeader = styled.h2`
    font-size: 11px;
    color: #46535e;
`;

